import Icon, {
  type IconName,
  type PhosphorIconName,
} from '@/components/atomic/icon'

interface IconBlockProps {
  icon: IconName | PhosphorIconName
  className?: string
  textColor?: string
  backgroundColor?: string
  isPhosphor?: boolean
  iconClassName?: string
  outline?: boolean
}

export function IconBlock({
  icon,
  className = '',
  textColor = '',
  backgroundColor = '',
  isPhosphor = false,
  iconClassName = '',
  outline = false,
}: IconBlockProps) {
  return (
    <span
      className={`flex items-center ${backgroundColor} rounded-sm p-1.5 ${className}`}
    >
      <Icon
        iconName={icon}
        className={`${textColor} ${iconClassName}`}
        isPhosphor={isPhosphor}
        outline={outline}
      />
    </span>
  )
}
